<body class="bg-gray-200">


<div class="grid grid-cols-11 h-screen">

  <!-- sidenav -->
  <div class="drop-shadow-lg p-6 bg-gray-100  hidden lg:block lg:col-span-2 overflow-y-auto">
    <app-admin-sidebar></app-admin-sidebar>
  </div>

  <!--content wrapper-->
  <div class="col-span-11 lg:col-span-9 pb-10 bg-stone-50">
    <app-navigation [isAdmin]="true" (openSideNav)="openSideNav()"></app-navigation>
    <div class="md:mx-10">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
</body>

<!-- side navigation -->
<div class="card flex justify-content-center">
  <p-drawer [(visible)]="isSideNavOpeon" position="left">
    <app-admin-sidebar (navigationClicked)="isSideNavOpeon = false"></app-admin-sidebar>
  </p-drawer>
</div>
